import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ReadonlyField from '../ReadonlyField';
import CheckboxField from '../CheckboxField';
import { resolveValue } from '../../../utils/fields';
import { extendedStateType } from '../../../types';
import { NO_STATE } from '../../../hooks/useExtendedState';

PrivilegedCheckboxField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.bool,
    state: extendedStateType,
};

PrivilegedCheckboxField.defaultProps = {
    sufficientReadPrivileges: null,
    value: undefined,
    state: NO_STATE,
};

function PrivilegedCheckboxField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        state,
        ...rest
    } = props;
    const { t } = useTranslation();
    const { userPrivileges } = useAuthentication();
    const resolvedValue = resolveValue(value, state);
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    let result = null;
    if (canWrite) {
        result = (
            <CheckboxField
                value={value}
                state={state}
                {...rest}
            />
        );
    } else if (canRead) {
        result = (
            <ReadonlyField
                value={
                    resolvedValue
                        ? t('misc.yes')
                        : t('misc.no')
                }
                state={state}
                {...rest}
            />
        );
    }
    return result;
}

export default PrivilegedCheckboxField;
